var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('head-top',{attrs:{"navActive":_vm.navActive},on:{"navClick":_vm.navClickFun}}),_vm._v(" "),_c('div',{staticClass:"description-first-bg"}),_vm._v(" "),_c('div',{staticClass:"description-first-main",domProps:{"innerHTML":_vm._s(_vm.innerHtml)}}),_vm._v(" "),_c('foot-bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bb99c84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/description-first.vue
// module id = null
// module chunks = 